// typograf-enable
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import PropTypes from 'prop-types';
import MosSelect from '@mos-front-components/public/es/components/MosSelect';

import MainData from '../../components/MainData';
import Passport from '../../components/Passport/Passport';
import ActRecord from '../../components/ActRecord/ActRecord';

import { getPermittedDocuments } from '../../helpers/getPermittedDocuments';
import {
  CITIZENSHIP_TYPES,
  MAIN_DATA_FIELD_NAMES,
} from '../../constants/citizenship';
import {
  changeMainData,
  blurMainData,
  submitMainData,
} from '../../store/mainData/actions';
import {
  changeMainDataChild,
  blurMainDataChild,
  submitMainDataChild,
} from '../../store/mainDataChild/actions';
import { selectChild } from '../../store/applicant/actions';
import {
  changePassportData,
  changeDocumentType,
  blurPassportData,
} from '../../store/passport/actions';
import {
  changeActRecordData,
  blurActRecordData,
} from '../../store/actRecord/actions';
import {
  changePassportDataChild,
  changeDocumentTypeChild,
  blurPassportDataChild,
} from '../../store/passportChild/actions';
import { saveDraft } from '../../store/draft/actions';
import {
  stepPersonStructuredSelector,
  stepPersonChildStructuredSelector,
  stepPersonStructuredSelectorPropTypes,
} from './stepPersonStructuredSelector';
import numberMask from './numberMask';
import { sendCMAAppealBusinessError } from '../../helpers/CMAStats';

import './StepPerson.pcss';

const reducedMainDataErrors = (errors, mainData) => {
  return Object.keys(errors).reduce((accum, key) => {
    if (mainData[key]) {
      return {
        ...accum,
        [key]: errors[key],
      };
    }
    return accum;
  }, {});
};

class StepPerson extends PureComponent {
  renderMainData = () => {
    const {
      mainDataValues,
      mainDataBlur,
      mainDataErrors,
      mainDataValid,
      parentApplicant,
      child,
      birthdateBeforeFourteenAndHalf,
      saveDraft,
    } = this.props;

    const props = {
      errors: reducedMainDataErrors(mainDataErrors, mainDataBlur),
    };

    if (!mainDataValues) {
      return null;
    }

    if (parentApplicant && !child) {
      return null;
    }

    // todo: хотелось бы понять как это работает mainDataBlur.undefined
    if (mainDataBlur && mainDataBlur.undefined) {
      props.errors = mainDataErrors;
    }

    return (
      <MainData
        isChild={parentApplicant}
        data={mainDataValues}
        editableFields={this.props.mainDataEditableFields}
        withSnils={parentApplicant}
        withBirthRegistrationPlace={birthdateBeforeFourteenAndHalf}
        onChange={(data, field) =>
          parentApplicant
            ? this.props.changeMainDataChild({ data, field })
            : this.props.changeMainData({ data, field })
        }
        onBlur={(data) =>
          parentApplicant
            ? this.props.blurMainDataChild(data)
            : this.props.blurMainData(data)
        }
        valid={mainDataValid}
        onSubmit={() =>
          parentApplicant
            ? this.props.submitMainDataChild(true)
            : this.props.submitMainData(true)
        }
        saveDraft={saveDraft}
        {...props}
      />
    );
  };

  renderPassport = () => {
    const {
      passportValues,
      passportBlur,
      passportErrors,
      parentApplicant,
      child,
      passportDisabled,
      passportEditableFields,
      mainDataValues: { citizenship, birthdate },
      underFourteen,
      saveDraft,
    } = this.props;
    const props = {};

    if (!passportValues) {
      return null;
    }

    if ((parentApplicant && !child) || underFourteen) {
      return null;
    }

    if (passportBlur) {
      props.errors = Object.keys(passportErrors).reduce((accum, key) => {
        if (passportBlur[key]) {
          return {
            ...accum,
            [key]: passportErrors[key],
          };
        }
        return accum;
      }, {});
    }

    const permittedDocuments = getPermittedDocuments(
      child ? 'CHILD' : 'PARTICIPANT',
      birthdate,
      CITIZENSHIP_TYPES[citizenship],
    );

    return (
      <React.Fragment key={passportValues.documentType}>
        <div className="StepPerson__Passport">
          <Passport
            citizenship={CITIZENSHIP_TYPES[citizenship]}
            disabled={passportDisabled}
            data={passportValues}
            permittedDocuments={permittedDocuments}
            documentType={passportValues.documentType}
            numberMask={numberMask(passportValues.documentType)}
            editableFields={passportEditableFields}
            onChange={(data, field) =>
              parentApplicant
                ? this.props.changePassportDataChild({ data, field })
                : this.props.changePassportData({ data, field })
            }
            onBlur={(data) =>
              parentApplicant
                ? this.props.blurPassportDataChild(data)
                : this.props.blurPassportData(data)
            }
            onDocumentTypeChange={(documentType) =>
              parentApplicant
                ? this.props.changeDocumentTypeChild(documentType)
                : this.props.changeDocumentType(documentType)
            }
            saveDraft={saveDraft}
            {...props}
          />
        </div>
      </React.Fragment>
    );
  };

  renderActRecord = () => {
    const {
      mainDataValues,
      mainDataErrors,
      passportValues,
      passportErrors,
      passportDisabled,
      actRecordData,
      actRecordBlur,
      actRecordSuggestions,
      actRecordSuggestionsFetching,
      actRecordSuggestionsFetchingError,
      changeActRecordData,
      blurActRecordData,
    } = this.props;

    return (
      <ActRecord
        mainData={{
          [MAIN_DATA_FIELD_NAMES.birthRegistrationPlace]: {
            value: mainDataValues[MAIN_DATA_FIELD_NAMES.birthRegistrationPlace],
            error: mainDataErrors[MAIN_DATA_FIELD_NAMES.birthRegistrationPlace],
          },
        }}
        passportData={{
          type: {
            value: passportValues.documentType,
            error: passportErrors.documentType,
            disabled: passportDisabled.documentType,
          },
        }}
        actRecordData={actRecordData}
        actRecordBlur={actRecordBlur}
        suggestions={actRecordSuggestions}
        fetching={actRecordSuggestionsFetching}
        fetchingError={actRecordSuggestionsFetchingError}
        onChange={changeActRecordData}
        onBlur={blurActRecordData}
        saveDraft={saveDraft}
        showHint={false}
        showTitle
      />
    );
  };

  renderInfoColumn = () => (
    <div className="ColumnWithInfo__info">
      <p className="ColumnWithInfo__infoParagraph">
        Данные о {this.props.parentApplicant ? 'детях' : 'заявителе'}{' '}
        заполняются из личного кабинета.
      </p>
      <p className="ColumnWithInfo__infoParagraph">
        <a
          className="Link"
          href="https://my.mos.ru/my/#/settings/profile"
          rel="noopener noreferrer"
          target="_blank"
        >
          Отредактируйте профиль
        </a>
        , если вы хотите изменить их.
      </p>
    </div>
  );

  checkHasNoChildren = () => {
    const {
      personChildren,
      parentApplicant,
      stepApplicantComplete,
      stepApplicantTypeComplete,
    } = this.props;
    if (
      stepApplicantComplete &&
      stepApplicantTypeComplete &&
      parentApplicant &&
      !personChildren.length
    ) {
      sendCMAAppealBusinessError({ stage: 'step' });
    }
  };

  componentDidMount() {
    this.checkHasNoChildren();
  }

  componentDidUpdate(prevProps) {
    this.checkHasNoChildren();
  }

  render() {
    if (this.props.parentApplicant && !this.props.stepApplicantComplete) {
      return null;
    }

    if (!this.props.stepApplicantTypeComplete) {
      return null;
    }

    const hasChildren = this.props.personChildren.length;

    if (this.props.parentApplicant && !hasChildren) {
      return (
        <div className="StepPerson">
          <div className="StepPerson__Childless">
            <p>
              <div className="StepPerson__Title">
                Подача апелляции недоступна
              </div>
            </p>
            <p className="StepPerson__AdditionalInfo">
              Подача заявления на рассмотрение апелляции на Портале вам не
              доступна, так как отсутствует подтверждение законного
              представительства (родства / опеки / попечительства) участника ГИА
              в личном кабинете.
            </p>
            <p className="StepPerson__AdditionalInfo">
              Как подтвердить законное представительство:
            </p>
            <ul className="List">
              <li>
                в личном кабинете зайти в{' '}
                <a
                  href="https://my.mos.ru/my/#/settings/family"
                  rel="noopener noreferrer"
                  target="_blank"
                  className="Link"
                >
                  раздел «Семья и дети»
                </a>
                ;
              </li>
              <li>внести информацию о ребенке;</li>
              <li>дождаться результата проверки.</li>
            </ul>
          </div>
          <p className="StepPerson__Childless__Info">
            Заявление на рассмотрение апелляции о несогласии с выставленными
            баллами может подавать сам участник ГИА по достижении им 14 лет,
            либо законный представитель при&nbsp;наличии подтвержденного
            законного представительства участника ГИА в личном кабинете.
            <br />
            Если участник ГИА не достиг 14 лет и в случае отсутствия у законного
            представителя подтвержденного законного представительства участника
            ГИА в личном кабинете, то&nbsp;любой из них может подать заявление
            на бумажном носителе в общественной приёмной регионального центра
            обработки информации города Москвы по адресу: г.&nbsp;Москва,
            Семёновская площадь, дом 4.
            <br />
            Законному представителю при себе необходимо иметь документ,
            удостоверяющий личность, и документ, подтверждающий законное
            представительство. Участнику ГИА потребуется документ,
            удостоверяющий личность. По всем дополнительным вопросам
            вы&nbsp;можете обратиться в региональный центр обработки информации
            города Москвы по&nbsp;телефону:{' '}
            <a
              className="Link"
              rel="noopener noreferrer"
              href="tel:+74996539450"
            >
              +7 499 653-94-50
            </a>
            .
          </p>
        </div>
      );
    }

    const { selectChild, child, parentApplicant, saveDraft } = this.props;

    const prettifiedChildren = this.props.personChildren.map((personChild) => ({
      value: personChild.item_id,
      text: `${personChild.surname} ${personChild.name}${
        personChild.patronymic ? ' ' : ''
      }${personChild.patronymic || ''}`,
    }));

    return (
      <div className="StepPerson">
        {parentApplicant ? (
          <>
            <div className="ColumnWithInfo">
              <p className="ColumnWithInfo__main StepPerson__AdditionalInfo">
                Подача апелляции о несогласии с выставленными баллами от
                родителя (законного представителя) доступна в случае наличия в
                разделе{' '}
                <a
                  className="Link"
                  href="https://my.mos.ru/my/#/settings/profile"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  Моя семья
                </a>{' '}
                в личном кабинете подтвержденной информации о ребенке.
              </p>
            </div>
            <div className="ColumnWithInfo">
              {this.renderInfoColumn()}
              <div className="ColumnWithInfo__main">
                <MosSelect
                  className="StepPerson__AdditionalInfo__Child"
                  placeholder={child ? 'Ребёнок' : 'Выберите ребёнка'}
                  value={(child && child.text) || ''}
                  suggestions={prettifiedChildren}
                  onChange={(selectedChild) => {
                    selectChild(selectedChild);
                    saveDraft();
                  }}
                  dropListView
                />
              </div>
            </div>

            {this.renderMainData()}
            {this.renderPassport()}
            {this.renderActRecord()}
          </>
        ) : (
          <div className="ColumnWithInfo">
            {this.renderInfoColumn()}
            <div className="ColumnWithInfo__main">
              {this.renderMainData()}
              {this.renderPassport()}
              {this.renderActRecord()}
            </div>
          </div>
        )}
      </div>
    );
  }
}

StepPerson.propTypes = {
  ...stepPersonStructuredSelectorPropTypes,
  changeMainData: PropTypes.func.isRequired,
  changeMainDataChild: PropTypes.func.isRequired,
  blurMainData: PropTypes.func.isRequired,
  blurMainDataChild: PropTypes.func.isRequired,
  submitMainData: PropTypes.func.isRequired,
  changePassportData: PropTypes.func.isRequired,
  changePassportDataChild: PropTypes.func.isRequired,
  changeDocumentType: PropTypes.func.isRequired,
  changeDocumentTypeChild: PropTypes.func.isRequired,
  blurPassportData: PropTypes.func.isRequired,
  blurPassportDataChild: PropTypes.func.isRequired,
  changeActRecordData: PropTypes.func.isRequired,
  blurActRecordData: PropTypes.func.isRequired,
  stepApplicantTypeComplete: PropTypes.bool,
  stepApplicantComplete: PropTypes.bool,
  parentApplicant: PropTypes.bool.isRequired,
  child: PropTypes.shape({}),
};

StepPerson.defaultProps = {
  stepApplicantTypeComplete: null,
};

export default compose(
  connect(
    (state, ownProps) =>
      ownProps.parentApplicant
        ? stepPersonChildStructuredSelector(state)
        : stepPersonStructuredSelector(state),
    (dispatch) =>
      bindActionCreators(
        {
          changeMainData,
          changeMainDataChild,
          blurMainData,
          blurMainDataChild,
          submitMainData,
          submitMainDataChild,
          changePassportData,
          changePassportDataChild,
          changeDocumentType,
          changeDocumentTypeChild,
          blurPassportData,
          blurPassportDataChild,
          changeActRecordData,
          blurActRecordData,
          selectChild,
          saveDraft,
        },
        dispatch,
      ),
  ),
)(StepPerson);
